import { render, staticRenderFns } from "./BaseTemplates.vue?vue&type=template&id=9fb9b92a"
import script from "./BaseTemplates.vue?vue&type=script&lang=js"
export * from "./BaseTemplates.vue?vue&type=script&lang=js"
import style0 from "./BaseTemplates.vue?vue&type=style&index=0&id=9fb9b92a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports